<template>
  <header class="header" @mouseleave="closeMega">
    <div class="header-inner">
      <button class="mobile-register-btn" @click="openRegisterModal">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="16" y1="11" x2="22" y2="11"/>
        </svg>
      </button>

      <div class="logo">
        <router-link to="/" @click="closeMega">
          <img src="@/assets/logo/logo2.png" alt="로고" />
        </router-link>
      </div>

      <nav class="nav-pc" @mouseenter="openMega">
        <ul class="nav-menu">
          <li class="nav-item" v-for="group in menuGroups" :key="group.title">
            <router-link
              :to="group.items.length ? group.items[0].path : group.path"
              class="nav-title"
              @click="closeMega"
            >
              {{ group.title }}
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="phone-box">
        <a href="tel:1688-4084">1688-4084</a>
      </div>

      <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 메가메뉴 (PC) -->
    <div class="mega-menu" :class="{ open: isMegaOpen }">
      <div class="mega-inner">
        <div
          v-for="group in menuGroups"
          :key="group.title"
          class="mega-column"
        >
          <h3 class="mega-column-title">{{ group.title }}</h3>
          <ul class="mega-list">
            <li v-if="!group.items.length">
              <router-link
                :to="group.path"
                class="mega-link"
                @click="closeMega"
              >
                {{ group.title }}
              </router-link>
            </li>
            <li v-for="item in group.items" :key="item.path">
              <router-link
                :to="item.path"
                class="mega-link"
                @click="closeMega"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 모바일 메뉴 -->
    <div class="nav-mobile" :class="{ open: isMobileMenuOpen }">
      <div class="mobile-menu-inner">
        <ul class="mobile-menu">
          <li v-for="group in menuGroups" :key="group.title" class="mobile-menu-item">
            <router-link
              v-if="!group.items.length"
              :to="group.path"
              class="mobile-menu-title"
              @click="closeMobileMenu"
            >
              {{ group.title }}
            </router-link>
            <template v-else>
              <button
                class="mobile-menu-title mobile-menu-toggle"
                :class="{ expanded: expandedGroups[group.title] }"
                @click="toggleGroup(group.title)"
              >
                {{ group.title }}
                <svg class="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              <ul v-show="expandedGroups[group.title]" class="mobile-submenu">
                <li v-for="item in group.items" :key="item.path">
                  <router-link
                    :to="item.path"
                    class="mobile-submenu-link"
                    @click="closeMobileMenu"
                  >
                    {{ item.title }}
                  </router-link>
                </li>
              </ul>
            </template>
          </li>
        </ul>
        <div class="mobile-phone">
          <a href="tel:1688-4084">1688-4084</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMobileMenuOpen: false,
      isMegaOpen: false,
      expandedGroups: {},
      menuGroups: [
        {
          title: '사업안내',
          items: [
            { title: '사업개요', path: '/overview' },
            { title: '입지환경', path: '/location' },
            { title: '오시는길', path: '/directions' }
          ]
        },
        {
          title: '단지안내',
          items: [
            { title: '프리미엄', path: '/premium' },
            { title: '커뮤니티', path: '/community' },
            { title: '단지배치도', path: '/site-plan' },
            { title: '동호수배치도', path: '/unit-plan' }
          ]
        },
        {
          title: '세대안내',
          items: [
            { title: '59A', path: '/household/59a' },
            { title: '59B', path: '/household/59b' },
            { title: '84A', path: '/household/84a' },
            { title: '84B', path: '/household/84b' }
          ]
        },
        {
          title: '방문예약하기',
          path: '/reservation',
          items: []
        }
      ]
    }
  },
  methods: {
    openMega() {
      this.isMegaOpen = true
    },
    closeMega() {
      this.isMegaOpen = false
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (!this.isMobileMenuOpen) {
        this.expandedGroups = {}
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.expandedGroups = {}
    },
    toggleGroup(title) {
      this.expandedGroups = {
        ...this.expandedGroups,
        [title]: !this.expandedGroups[title]
      }
    },
    openRegisterModal() {
      window.dispatchEvent(new CustomEvent('open-register-modal'))
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.header-inner {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.logo {
  flex-shrink: 0;
}

.logo a {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo img {
  height: 60px;
  filter: brightness(0) saturate(100%) invert(72%) sepia(46%) saturate(370%) hue-rotate(5deg) brightness(92%) contrast(86%);
}

/* PC 네비게이션 */
.nav-pc {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
}

.nav-menu {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  list-style: none;
}

.nav-item {
  position: relative;
}

.nav-title {
  display: block;
  padding: 30px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  letter-spacing: -0.3px;
  text-align: center;
}

.nav-title:hover {
  color: var(--main-color1);
}

/* 메가메뉴 */
.mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: opacity 0.25s ease, visibility 0.25s ease, transform 0.25s ease;
  z-index: 999;
}

.mega-menu.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.mega-inner {
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
  padding: 40px 0 50px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.mega-column {
  min-width: 0;
  padding: 0 16px;
}

.mega-column-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 2px solid var(--main-color1);
  letter-spacing: -0.3px;
}

.mega-list {
  list-style: none;
}

.mega-list li {
  margin-bottom: 4px;
}

.mega-link {
  display: block;
  padding: 8px 0;
  color: #555;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s, padding-left 0.2s;
  letter-spacing: -0.3px;
}

.mega-link:hover {
  color: var(--main-color1);
  padding-left: 6px;
}

/* 전화박스 */
.phone-box {
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  border-radius: 50px;
  padding: 12px 28px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.phone-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(196, 108, 88, 0.3);
}

.phone-box a {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.3px;
}

/* 모바일 버튼들 */
.mobile-register-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #333;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  gap: 6px;
  padding: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 6px);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -6px);
}

/* 모바일 메뉴 */
.nav-mobile {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100vh - 80px);
  background: #fff;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
}

.nav-mobile.open {
  transform: translateX(0);
}

.mobile-menu-inner {
  padding: 20px 25px 40px;
}

.mobile-menu {
  list-style: none;
}

.mobile-menu-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px 4px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  text-decoration: none;
  letter-spacing: -0.3px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: color 0.2s;
}

.mobile-menu-title:hover,
.mobile-menu-title:active {
  color: var(--main-color1);
}

.chevron {
  width: 18px;
  height: 18px;
  color: #999;
  transition: transform 0.25s ease;
}

.mobile-menu-toggle.expanded .chevron {
  transform: rotate(180deg);
  color: var(--main-color1);
}

.mobile-submenu {
  list-style: none;
  padding: 0 0 12px 12px;
}

.mobile-submenu li {
  border-left: 2px solid #eee;
}

.mobile-submenu-link {
  display: block;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 500;
  color: #666;
  text-decoration: none;
  transition: color 0.2s, background 0.2s;
  border-radius: 6px;
}

.mobile-submenu-link:hover,
.mobile-submenu-link:active {
  color: var(--main-color1);
  background: #f7f7f7;
}

.mobile-phone {
  margin-top: 36px;
  text-align: center;
}

.mobile-phone a {
  display: inline-block;
  background: linear-gradient(135deg, var(--main-color1) 0%, var(--main-color2) 100%);
  color: #fff;
  padding: 16px 50px;
  border-radius: 50px;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
}

/* 반응형 */
@media (max-width: 1280px) {
  .header-inner {
    padding: 0 30px;
  }

  .nav-pc {
    width: 720px;
  }

  .nav-title {
    padding: 30px 12px;
    font-size: 15px;
  }

  .mega-inner {
    width: 720px;
    padding: 36px 0 44px;
  }

  .mega-column {
    padding: 0 12px;
  }
}

@media (max-width: 1024px) {
  .header {
    background: var(--main-color1);
  }

  .nav-pc,
  .phone-box,
  .mega-menu {
    display: none;
  }

  .mobile-register-btn {
    display: flex;
    position: absolute;
    left: 20px;
    color: #fff;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-menu-btn span {
    background: #fff;
  }

  .nav-mobile {
    display: block;
    top: 65px;
    height: calc(100vh - 65px);
  }

  .header-inner {
    height: 65px;
    padding: 0 20px;
    justify-content: center;
  }

  .logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .logo a {
    gap: 5px;
  }

  .logo img {
    height: 48px;
    filter: brightness(0) invert(1);
  }

  .mobile-menu-btn {
    position: absolute;
    right: 20px;
  }
}
</style>
